import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {platformBrowser} from "@angular/platform-browser";
import * as Sentry from '@sentry/angular';

import {environment} from './environments/environment';
import {StancheckModule} from "./app/stancheck/stancheck.module";

Sentry.init({
  dsn: 'https://e2b98af9fd3b41a7b656bd7473e29ca8@sentry.co2online.de/19',
  beforeBreadcrumb(breadcrumb) {
    if (breadcrumb.category === 'fetch' && breadcrumb.data && breadcrumb.data.url && breadcrumb.data.url.match(/^data/)) {
      return null;
    }
    return breadcrumb;
  },

  enabled: environment.production === true,

  environment: window.location.host.indexOf('-dev') > 0 ? 'stage' : 'production',

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0,

  // ignore some errors
  ignoreErrors: [
    'Non-Error exception captured',
    'Non-Error promise rejection captured'
  ]
});
Sentry.setTag('page_locale', navigator['browserLanguage'] ?? navigator.language);

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(StancheckModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
